import { Box, Skeleton, Stack } from '@mui/material'
import { ItemImageAreaSkeleton } from 'utoniq-ui'

export const SkeletonLoader = () => {
  return (
    <Box sx={{ height: '100%' }}>
      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          flex: '1 0 auto',
        }}
      >
        <Stack
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          flex={1}
        >
          <ItemImageAreaSkeleton size="xx-large" />
          <Box sx={{ mt: 6, mb: 2 }}>
            <Skeleton variant="circular" width={30} height={30} />
          </Box>
        </Stack>

        <Stack
          direction="row"
          sx={{ justifyContent: 'flex-start', py: 2, px: 4 }}
        >
          {[1, 2, 3, 4].map(index => {
            return (
              <Skeleton
                key={index}
                variant="rectangular"
                height={40}
                width={40}
                sx={{ m: 1 }}
              />
            )
          })}
        </Stack>
      </Box>
    </Box>
  )
}
